import { getFetch, postFetch, postFormFetch, getJsonp } from '../util/service'
import { http } from '../util/axios'
export function getExternalFiles(uri,params){
    return http.get(uri,{...params})
}

//登录有页面异步获取接口
export function loginAsyncData(){
    const str = window.location.search
    const data = postFormFetch(`/passport/asyncLogin${str}`,)
    return data
}
//登录接口
export function submitLogin(querystring,params){
    const data = postFormFetch(`/passport/sigin?${querystring}`, params)
    return data
}